import { Component, createRef } from 'react'
import styles from '~/styles/search.results.module.css'
import types from '~/types/search.ts'

export default class Results extends Component {
	static getInitialProps() {
		return {
			namespacesRequired: [ 'common' ],
		}
	}
	
	constructor(props) {
		super(props)
		this.state = {
		}
		this._mainRef = createRef()
		this._resultsRef = createRef()
	}
	
	render(): JSX.Element | null {
		if (this.props.show) {
			const results = this._getResults()
			if (results) {
				return (
					<div
						className={styles.main}
						style={{
							maxWidth: this.state.width || '100%'
						}}
						ref={this._mainRef}
					>
						<div
							ref={this._resultsRef}
						>
							{results}
						</div>
					</div>
				)
			} else {
				return null
			}
		} else {
			return null
		}
	}
	
	componentDidMount() {
		try {
			const width = this.props.inputRef.current.getBoundingClientRect().width
			if (width !== this.state.width) {
				this.setState({ width })
			}
		} catch(e) {}
	}
	
	private _getResults(): Array<JSX.Element> | null {
		let results = []
		this.props.results.sort((a, b) => {
			const clearA = a.replace(/^[^a-zа-я0-9]+?(.+)$/i, '$1')
			const clearB = b.replace(/^[^a-zа-я0-9]+?(.+)$/i, '$1')
			if (clearA > clearB) {
				return 1
			} else if (clearA < clearB) {
				return -1
			} else {
				return 0
			}
		}).forEach((result, i) => {
			if (i < this.props.limit) {
				const isSelected = (result === this.props.selectedItem)
				const className = styles.itemName + (isSelected ? ' ' + styles.selected : '')
				results.push((
					<div
						key={result}
						className={className}
						onClick={this._onClick.bind(this, result)}
					>
						{result}
					</div>
				))
			}
		})
		this._scrollToSelected()
		if (results.length) {
			return results
		} else {
			return null
		}
	}
	
	private _onClick(result): void {
		this.props.onFound(result)
	}
	
	private async _scrollToSelected(): void {
		try {
			const mainRect = this._mainRef.current.getBoundingClientRect()
			const resultsRect = this._resultsRef.current.getBoundingClientRect()
			const fraction = (this.props.selectedId / Math.min(this.props.results.length, this.props.limit))
			const selectedTop = resultsRect.height * fraction + mainRect.top
			const isToLow = selectedTop > ((mainRect.bottom - mainRect.top) * 0.8 + mainRect.top)
			const isToHigh = selectedTop < ((mainRect.bottom - mainRect.top) * 0.3 + mainRect.top)
			if (isToLow || isToHigh) {
				const scroll = (selectedTop - ((mainRect.bottom - mainRect.top) * 0.5 + mainRect.top))
				this._mainRef.current.scrollTop = scroll
			}
		} catch(e) {}
	}
}